import React from 'react';
import { motion } from 'framer-motion';
import usePageTitle from '../hooks/usePageTitle';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import HowItWorksSection from './HowItWorksSection';
import AppPreviewSection from './AppPreviewSection';
import PartnerVenuesSection from './PartnerVenuesSection';
import WhyDateniteSection from './WhyDateniteSection';
import Footer from './Footer';

const Home = () => {
  usePageTitle();
  
  return (
    <div className="App relative min-h-screen overflow-x-hidden">
      <Navigation />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="w-full relative z-10"
      >
        <HeroSection />
        <section id="how-it-works" className="w-full">
          <HowItWorksSection />
        </section>
        <section id="app-preview" className="w-full">
          <AppPreviewSection />
        </section>
        <section id="venues" className="w-full">
          <PartnerVenuesSection />
        </section>
        <section id="why-datenite" className="w-full">
          <WhyDateniteSection />
        </section>
        <Footer />
      </motion.div>
    </div>
  );
};

export default Home;
